// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BrowserLogger from 'alife-logger'
import App from './App'
import router from './router'
import {
  Button,
  Menu,
  Submenu,
  Carousel,
  CarouselItem,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Pagination,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  InputNumber,
  Radio,
  Checkbox,
  RadioButton,
  RadioGroup,
  DatePicker,
  Badge,
  Dialog,
  Steps,
  Step,
  Cascader,
  Popover,
  Tooltip,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Upload,
  Loading,
  Message,
  MessageBox,
  Card,
  Image,
  MenuItem} from 'element-ui'
// eslint-disable-next-line no-redeclare
import { Toast, Popup, InfiniteScroll, Indicator } from 'mint-ui'
import store from './store/index'
import './assets/sass/index.scss'
import './assets/font/iconfont.css'
import './assets/icon/iconfont.css'
import './utils/globalVueConfig'
import '@/components/global'
import { preventReClick, int } from './utils/directive'
import * as baseMethods from './utils/baseMethod'
import VueClipboard from 'vue-clipboard2';
import {message} from './utils/resetMessage';

// 阿里ARMS前端监控
BrowserLogger.singleton(
  {
    pid:"c3fir99soy@2bf0cefc9352251",
    appType:"web",
    imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",
    sendResource:true,
    enableLinkTrace:true,
    behavior:true
  }
);

Vue.prototype.$message = message;

Vue.config.productionTip = false
Vue.prototype.baseMethods = baseMethods
Vue.use(preventReClick)
Vue.use(int)

Vue.use(Button)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Pagination)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(RadioButton)
Vue.use(DatePicker)
Vue.use(RadioGroup)
Vue.use(Badge)
Vue.use(Dialog)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Tooltip)
Vue.use(Cascader)
Vue.use(Popover)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Upload)
Vue.use(MenuItem)
Vue.use(Image)
Vue.use(Card)

Vue.use(Loading.directive)
Vue.use(VueClipboard)
// Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert

Vue.component(Popup.name, Popup)
Vue.use(InfiniteScroll)
// Vue.component(InfiniteScroll.name, InfiniteScroll)
Vue.prototype.$toast = Toast
Vue.prototype.$indicator = Indicator
Vue.prototype.openLoading = function() {
  const loading = this.$loading({           // 声明一个loading对象
    lock: true,                             // 是否锁屏
    text: '正在加载...',                     // 加载动画的文字
    spinner: 'el-icon-loading',             // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.3)',       // 背景颜色
    target: '.sub-main',                    // 需要遮罩的区域
    body: true,
    customClass: 'mask'                     // 遮罩层新增类名
  })
  setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close();                        // 关闭遮罩层
  },5000)
  return loading;
}

router.beforeEach((to, from, next) => {

  /* 路由发生变化修改页面meta */
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js